module.exports = __webpack_public_path__ + "img/DE00283.76129288.svg";